import * as actions from './Actions';

const parseOption = (payload) => {
  if (!payload) return undefined;
  return {
    optionId: Number(payload.optionId ?? payload.id ?? 0),
    questionId: Number(payload.questionId ?? 0),
    optionText: payload.optionText || '',
    isCorrect: Boolean(payload.isCorrect ?? false),
    order: Number(payload.order ?? 0),
    createdAt: payload.createdAt || null,
    updatedAt: payload.updatedAt || null,
  };
};

const parseQuestion = (payload) => {
  if (!payload) return undefined;
  const options = Array.isArray(payload.options) ? payload.options.map(parseOption).filter(Boolean) : [];
  return {
    questionId: Number(payload.questionId ?? payload.id ?? 0),
    quizId: Number(payload.quizId ?? 0),
    skillId: Number(payload.skillId ?? 0),
    questionType: payload.questionType || '',
    questionText: payload.questionText || '',
    hint: payload.hint || null,
    points: Number(payload.points ?? 0),
    timeLimit: payload.timeLimit ?? null,
    order: Number(payload.order ?? 0),
    isRequired: Boolean(payload.isRequired ?? false),
    explanation: payload.explanation || null,
    createdAt: payload.createdAt || null,
    updatedAt: payload.updatedAt || null,
    options,
  };
};

const parseAttemptLite = (payload) => {
  if (!payload) return undefined;
  return {
    attemptId: Number(payload.attemptId ?? payload.id ?? 0),
    user: payload.user ? {
      id: Number(payload.user.id ?? payload.userId ?? 0),
      username: payload.user.username || payload.user.name || '',
      email: payload.user.email || '',
    } : undefined,
  };
};

const parseResponse = (payload) => {
  if (!payload) return null;
  return {
    responseId: Number(payload.responseId ?? payload.id ?? 0),
    attemptId: Number(payload.attemptId ?? 0),
    questionId: Number(payload.questionId ?? 0),
    optionId: payload.optionId != null ? Number(payload.optionId) : null,
    textResponse: payload.textResponse ?? null,
    isCorrect: Boolean(payload.isCorrect ?? false),
    pointsEarned: Number(payload.pointsEarned ?? 0),
    createdAt: payload.createdAt || null,
    updatedAt: payload.updatedAt || null,
    // Expanded
    attempt: parseAttemptLite(payload.attempt),
    question: parseQuestion(payload.question),
    option: parseOption(payload.option),
  };
};

export const quizResponsesReducer = (state = [], action) => {
  switch (action.type) {
    case actions.INITIALIZE_QUIZ_RESPONSES: {
      const list = Array.isArray(action.payload) ? action.payload : [];
      return list.map(parseResponse).filter(Boolean);
    }
    case actions.ADD_QUIZ_RESPONSE:
      return [...state, parseResponse(action.payload)].filter(Boolean);
    case actions.UPDATE_QUIZ_RESPONSE:
      return state.map(r => (r.responseId === (action.payload?.responseId ?? action.payload?.id) ? parseResponse(action.payload) : r));
    case actions.DELETE_QUIZ_RESPONSE: {
      const id = Number(action.responseId ?? action.id);
      return state.filter(r => r.responseId !== id);
    }
    case actions.CLEAR_QUIZ_RESPONSES:
      return [];
    default:
      return state;
  }
};

export default quizResponsesReducer;
